export default __webpack_public_path__ + "static/media/account-drop-down-rectangle.0b235e4f.svg";